import React from 'react';
import { Typography } from 'antd';
import FeaturedContentList from '../components/FeaturedContentList';

const FeaturedContent: React.FC = () => (
  <div>
    <Typography.Title level={4} style={{ margin: 0 }}>Featured Contents</Typography.Title>
    <div style={{ marginTop: 32 }}>
      <FeaturedContentList />
    </div>
  </div>
);

export default FeaturedContent;
